<rcl-header
  id="health-rcl-header"
  [bg]="'assets/images/checkin/hero.jpg'"
  [expandable]="false"
  >
  <img
    id="health-rcl-header__img-logo"
    inline-svg
    title="home"
    class="royal-header-logo"
    alt="Royal header logo"
    src="assets/icons/royal-logo.svg"
    />
  <p id="health-rcl-header__icon-text" class="rcl-h5 rcl-header-icon-text"></p>

  <rcl-menu-button id="health-rcl-header__menu-button" [text]="'My account'" [expanded]="showMenu" (onToggleNav)="showMenu = !showMenu">
  </rcl-menu-button>

  @if (!isSafari) {
    <rcl-menu-button-dropdown id="health-rcl-header__menu-dropdown">
      <app-user-menu id="health-rcl-header__menu-dropdown__user-menu" [(showMenu)]="showMenu"></app-user-menu>
    </rcl-menu-button-dropdown>
  }
</rcl-header>

@if (isSafari) {
  <app-user-menu id="health-user-menu" [(showMenu)]="showMenu"></app-user-menu>
}

<rcl-main-content id="health-main-content">
  <h1 id="health-main-content__title">Health Check Page</h1>
</rcl-main-content>
